<script>
   /*********************************************************************/
   /* HotellingEllipse                                                  */
   /* --------------------                                              */
   /* shows Hottelling T2 ellipse on top of the scores plot             */
   /*********************************************************************/

   import { Vector } from 'mdatools/arrays';
   import { Lines } from 'svelte-plots-basic/2d';
   import { qchisq } from 'mdatools/distributions';

   let {
      resobj,                              // JSON with PCA result object
      comp,                                // selected components
      lineColor = '#606060',               // color for the ellipse
      lineType = 2,                        // line type for the ellipse
      alpha = 0.05,                        // confidence level
      xRange = $bindable(),          // range of x-coordinates
      yRange = $bindable(),          // range of y-coordinates
   } = $props();

   /*****************************************/
   /* Component code                        */
   /*****************************************/

   const angles = Vector.seq(0, 2 * Math.PI, 0.05);

   function getCoordinates(res, comp, fun, angles) {
      const lambda = res.eigenvals[comp - 1];
      const c = qchisq(1 - alpha, 2);
      const a = Math.sqrt(c * lambda);
      const x = Vector.zeros(angles.length);
      for (let i = 0; i < angles.length; i++) {
         x.v[i] = a * fun(angles.v[i]);
      }
      return [x, -a, a];
   }


   // reactive statement to track chenges in "reobj" and "comp[0]" (x-axis)
   let compX = $derived(comp ? comp[0] : null);
   let coordsX = $derived(compX ? getCoordinates(resobj, compX, Math.cos, angles) : null);

   $effect(() => {
      xRange = coordsX ? [coordsX[1], coordsX[2]] : null;
   });

   // reactive statement to track chenges in "reobj" and "comp[1]" (y-axis)
   let compY = $derived(comp ? comp[1] : null);
   let coordsY = $derived(compY ? getCoordinates(resobj, compY, Math.sin, angles) : null);

   $effect(() => {
      yRange = coordsY ? [coordsY[1], coordsY[2]] : null;
   });
</script>

{#if coordsX && coordsY}
<Lines xValues={coordsX[0]} yValues={coordsY[0]} {lineColor} {lineType}/>
{/if}